import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LoadingSkeletonDirective2 } from 'common-ui';
import { IfInViewportDirective } from 'common-util';
import { CartItemResultLayoutComponent } from '../cart-item-result-layout';
import { ItemId } from 'products-data';
import { GridCellDirective, InfiniteGridLayoutComponent } from 'page-layouts-ui';

@Component({
  selector: 'ideal-cart-item-result-list',
  imports: [
    CartItemResultLayoutComponent,
    IfInViewportDirective,
    LoadingSkeletonDirective2,
    InfiniteGridLayoutComponent,
    GridCellDirective,
  ],
  standalone: true,
  templateUrl: './cart-item-result-list.component.html',
  styleUrl: './cart-item-result-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartItemResultListComponent {
  public readonly ids = input<(ItemId | null)[]>([]);
}
